import { Route, RouteProps, Redirect } from "react-router-dom";
export const AdminApproverBMRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {

    let result = JSON.parse(localStorage.getItem("user"));
    console.log("ressss", result)
    return <Route
        {...rest}
        render={props =>
            result.isAdmin || result.isBoardMember || result.userTypeId == 5 ? (
                <Layout>
                    <Component {...props} />
                </Layout>
            ) :
                (
                    <Redirect to={{
                        pathname: "/",
                    }} />
                )
        }
    />
}